import { render } from "./MessageWindowItem.vue?vue&type=template&id=8099af94&scoped=true"
import script from "./MessageWindowItem.vue?vue&type=script&lang=js"
export * from "./MessageWindowItem.vue?vue&type=script&lang=js"

import "./MessageWindowItem.vue?vue&type=style&index=0&id=8099af94&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8099af94"]])

export default __exports__